import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react';

export function SSOCallback() {
  return <AuthenticateWithRedirectCallback />;
}
